import { render, staticRenderFns } from "./ConfigInvoice.vue?vue&type=template&id=47eeb6fa&scoped=true&"
import script from "./ConfigInvoice.vue?vue&type=script&lang=js&"
export * from "./ConfigInvoice.vue?vue&type=script&lang=js&"
import style0 from "./ConfigInvoice.vue?vue&type=style&index=0&id=47eeb6fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47eeb6fa",
  null
  
)

export default component.exports